module.exports = __webpack_public_path__ + "static/media/joyce_williams.bb5f742e.jpg";